<aside [style.width]="width">
  <customer-logo [logo]="logo"></customer-logo>
  <nz-divider></nz-divider>
  <ng-content select='app-sidebar-actions'></ng-content>
</aside>
